import React from "react";
import { Tooltip, Button } from "antd";

const ActionIconButton = ({ icon, tooltip, onClick, disabled = false, ariaLabel, testId }) => {
  return (
    <Tooltip title={tooltip} mouseEnterDelay={0.2}>
      <Button
        type="text"
        size="small"
        icon={icon}
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel || tooltip}
        data-testid={testId}
        className="flex-row-centered items-center justify-center w-8 h-8 text-grey-500 hover:text-brand-500 hover:bg-grey-100 rounded transition-colors"
      />
    </Tooltip>
  );
};

export default ActionIconButton;
